import { getServerURL } from "../shared/sharedFunctions";
import companyService from "./companyService";
import domainService from "./domainService";
import userService from "./userService";

const RiskService = () => {
	const pub = {};
	
	let risks = null;
	pub.Risks = () => { return risks; }
	pub.VisibleRisks = () => {
		const domainAddresses = domainService.VisibleDomainAddresses();
		return risks.filter((risk) => {
			return domainAddresses.includes(risk.domain);
		});
	}
	
	pub.syntheticIds = [];
	
	const init = () => {
	};
	
	pub.getRiskCount = (severity) => {
		const visibleRisks = pub.VisibleRisks();
		
		let count = 0;
		for (let i = 0; i < visibleRisks.length; i++) {
			if (visibleRisks[i].severity === severity) {
				count += 1;
			}
		}
		
		return count;
	};
	
	pub.addSyntheticId = async (system, reference) => {
		const req = {
			method: "POST",
			headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() },
			body: JSON.stringify({
				companyId: companyService.selectedCompany.id,
				system: system,
				reference: reference
			})
		};
		
		let response = await fetch(`${getServerURL()}/api/jobs/syntheticid`, req);
		if (response.status !== 200) {
			throw new Error(response.staus);
		}
	};
	
	init();
	return pub;
};

export default RiskService();